// License disciplinary-actions filter registry. Drives the
// Disciplinary tab on the license detail page.

import { createDateRangeFilter } from './factories';
import type { FilterRegistry } from './types';

const LICENSE_DISCIPLINARY_LIST_KEYS: ReadonlyArray<string> = [
	'license-disciplinary-embedded',
];

export const licenseDisciplinaryFilters: FilterRegistry = {
	discStatus: {
		type: 'multi-select',
		label: 'Status',
		placeholder: 'Select status...',
		colorScheme: 'orange',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		// Status vocabulary matches `LicenseDisciplinaryActionEntity.status`
		// (Open / Resolved / Dismissed). Keep them title-cased — the column
		// is varchar with no normalization, and the existing UI renders
		// them as-is.
		options: [
			{ id: 'Open', label: 'Open' },
			{ id: 'Resolved', label: 'Resolved' },
			{ id: 'Dismissed', label: 'Dismissed' },
		],
		queryParamName: 'discStatus',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'license_disciplinary_action',
			fieldName: 'status',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_DISCIPLINARY_LIST_KEYS],
	},

	discSeverity: {
		type: 'multi-select',
		label: 'Severity',
		placeholder: 'Select severity...',
		colorScheme: 'red',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		options: [
			{ id: 'Critical', label: 'Critical' },
			{ id: 'High', label: 'High' },
			{ id: 'Medium', label: 'Medium' },
			{ id: 'Low', label: 'Low' },
		],
		queryParamName: 'discSeverity',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'license_disciplinary_action',
			fieldName: 'severity',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_DISCIPLINARY_LIST_KEYS],
	},

	discDateRange: {
		...createDateRangeFilter({
			label: 'Action Date',
			objectTable: 'license_disciplinary_action',
			dateField: 'actionDate',
			listKeys: [...LICENSE_DISCIPLINARY_LIST_KEYS],
		}),
		queryParamName: 'discDateRange',
	},
};
